import * as React from 'react'
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import { useRecordContext } from 'react-admin';

import { RRule } from 'rrule'

const RecurrenceField = (props) => {
    const { source } = props;
    const record = useRecordContext(props);

    const rule = RRule.fromString(record[source]);

    return (<Typography
        component="span"
        variant="body2"
    >
        {rule.toText()}
    </Typography>
    );
};

RecurrenceField.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

export default RecurrenceField;
